import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-high-value-indicator',
  templateUrl: './high-value-indicator.component.html',
  standalone: false
})
export class HighValueIndicatorComponent {
  @Input() capture: { candidate: { highValue: boolean } };
}
